(() => {
  const key = 'rc-newsletter-v1';
  const day = 86400000;
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const dialog = root.querySelector('dialog');
    const opener = root.querySelector('[data-newsletter-open]');
    if (!dialog || typeof dialog.showModal !== 'function') {
      if (opener) opener.hidden = true;
      return;
    }
    const state = root.querySelector('[data-newsletter-state]');
    let previousFocus;
    let previousOverflow;
    let timer;
    let waitingForEntry = false;
    const read = () => {
      try { return JSON.parse(localStorage.getItem(key) || '{}') || {}; }
      catch (_) { return {}; }
    };
    const write = value => {
      try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) { /* Private browsing may disable storage. */ }
    };
    const open = () => {
      clearTimeout(timer);
      if (document.documentElement?.classList.contains('rc-door-active')) { waitingForEntry = true; return; }
      if (!root.isConnected || dialog.open) return;
      previousFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      const target = state || root.querySelector('input[type="email"]');
      if (target) target.focus({ preventScroll: true });
    };
    const close = () => { if (dialog.open) dialog.close(); };
    const entryFinished = () => { if (waitingForEntry) { waitingForEntry = false; timer = setTimeout(open, 1500); } };
    document.addEventListener('rc:intro:end', entryFinished);
    opener.addEventListener('click', open);
    root.querySelector('[data-newsletter-close]').addEventListener('click', close);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
    });
    dialog.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow;
      const saved = read();
      write({ ...saved, dismissedUntil: Date.now() + Number(root.dataset.cooldown || 7) * day });
      if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
    });
    // Shopify confirms subscription on the returned page, never on a submit click.
    if (state) {
      if (state.dataset.newsletterState === 'success') write({ subscribed: true });
      open();
    } else if (!window.Shopify?.designMode && root.dataset.auto === 'true' && root.dataset.customerSubscribed !== 'true') {
      const saved = read();
      if (!saved.subscribed && !(saved.dismissedUntil > Date.now())) timer = setTimeout(open, Number(root.dataset.delay || 5) * 1000);
    }
    // Local preview only: never POST an email or mark the visitor as subscribed.
    if (root.dataset.preview === 'true') {
      root.querySelector('form').addEventListener('submit', event => {
        event.preventDefault();
        let message = root.querySelector('[data-preview-message]');
        if (!message) {
          message = document.createElement('p');
          message.className = 'rc-newsletter__status';
          message.dataset.previewMessage = 'true';
          message.setAttribute('role', 'status');
          root.querySelector('form').appendChild(message);
        }
        message.textContent = 'Preview only — no email was submitted. The uploaded theme uses Shopify subscriptions.';
      });
    }
    root.addEventListener('rc-newsletter:destroy', () => { clearTimeout(timer); document.removeEventListener('rc:intro:end', entryFinished); close(); });
  }
  document.querySelectorAll('[data-rc-newsletter]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-rc-newsletter]').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-rc-newsletter]').forEach(root => root.dispatchEvent(new Event('rc-newsletter:destroy'))));
})();
